import { useState } from 'react';
import api from '../lib/api';
import { useAuth } from '../hooks/useAuth';

export default function BacklinkGapPage() {
  const [domains, setDomains] = useState(['', '', '']);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  const { updateCredits } = useAuth();

  function updateDomain(i, v) { const n=[...domains]; n[i]=v; setDomains(n); }

  async function analyze() {
    const clean = domains.map(d=>d.trim()).filter(Boolean);
    if (clean.length < 2) { setError('At least 2 domains'); return; }
    setError(''); setLoading(true); setData(null);
    try {
      const res = await api.post('/backlinks/gap', { domains: clean });
      setData(res.data.data);
      updateCredits(res.data.credits_remaining);
    } catch (e) { setError(e.response?.data?.error || 'Failed'); } finally { setLoading(false); }
  }

  return (
    <div className="fade-up">
      <div className="page-header">
        <h1 className="page-title">Backlink Gap</h1>
        <p className="page-sub">Find backlink opportunities your competitors have but you don't · 5 credits</p>
      </div>

      <div className="card" style={{ marginBottom: 16 }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 10, marginBottom: 12 }}>
          {domains.map((d,i) => <input key={i} className="input" placeholder={`Domain ${i+1}`} value={d} onChange={e=>updateDomain(i,e.target.value)} />)}
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <button className="btn btn-orange" onClick={analyze} disabled={loading}>{loading ? 'Analyzing...' : 'Find Opportunities →'}</button>
          <button className="btn btn-white" onClick={()=>setDomains([...domains,''])} disabled={domains.length>=5}>+ Add</button>
        </div>
        {error && <div style={{ marginTop: 10, color: '#FF3D57', fontSize: 13, background: '#FFEBEE', padding: '8px 12px', borderRadius: 6 }}>{error}</div>}
      </div>

      {loading && <div className="card"><div className="skeleton" style={{ height: 200 }} /></div>}

      {data && (
        <>
          <div className="metric-grid">
            {data.summary.map(s => (
              <div key={s.domain} className="card" style={{ margin: 0 }}>
                <div className="metric-label">{s.domain}</div>
                <div className="metric-value" style={{ fontSize: 18 }}>{s.backlinks.toLocaleString()} links</div>
                <div className="metric-sub">{s.refDomains.toLocaleString()} domains · AS {s.authorityScore}</div>
              </div>
            ))}
          </div>

          <div className="card">
            <div className="card-header"><span className="card-title">Link Opportunities ({data.opportunities.length})</span><span className="badge badge-orange">High value</span></div>
            <div className="table-wrap">
              <table className="table">
                <thead><tr><th>Opportunity Domain</th><th>AS</th><th>Backlinks</th><th>Missing From</th></tr></thead>
                <tbody>
                  {data.opportunities.map((o,i) => (
                    <tr key={i}><td style={{ fontWeight: 600 }}>{o.domain}</td><td><span className={`badge ${o.authorityScore>70?'badge-green':o.authorityScore>40?'badge-yellow':'badge-red'}`}>{o.authorityScore}</span></td><td>{o.backlinks.toLocaleString()}</td><td><span style={{ fontSize: 11, background: '#FFEBEE', color: '#FF3D57', padding: '2px 6px', borderRadius: 4 }}>{o.missingFrom.join(', ')}</span></td></tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
